import { cx } from '#/Scripts/utilities/cx';

interface BasicErrorProps {
  error: string;
  name: string;
  className?: string;
}

/**
 * CSS class name for error text.
 */
export const ERROR_TEXT_CLASS = 'error-text';

export const BasicError = ({ error, className, name }: BasicErrorProps) => {
  return (
    <p className={cx(ERROR_TEXT_CLASS, className)} id={`error-${name}`} role="alert">
      {error}
    </p>
  );
};
